
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

interface NewsletterFormContentProps {
  email: string;
  setEmail: (email: string) => void;
  firstName: string;
  setFirstName: (firstName: string) => void;
  lastName: string;
  setLastName: (lastName: string) => void;
  acceptNewsletter: boolean;
  setAcceptNewsletter: (accept: boolean) => void;
  isSubmitting: boolean;
  emailError: string;
  setEmailError: (error: string) => void;
  handleSubmit: (e: React.FormEvent) => Promise<void>;
  isModal?: boolean;
  standalone?: boolean;
}

export function NewsletterFormContent({
  email,
  setEmail,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  acceptNewsletter,
  setAcceptNewsletter,
  isSubmitting,
  emailError,
  setEmailError,
  handleSubmit,
  isModal = false,
  standalone = false
}: NewsletterFormContentProps) {
  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="email" className="text-center block mx-auto">Email</Label>
        <Input
          id="email"
          type="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setEmailError("");
          }}
          placeholder="votre@email.com"
          required
          className={`${emailError ? "border-red-500" : ""}`}
        />
        {emailError && <p className="text-red-500 text-sm mt-1">{emailError}</p>}
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="firstName" className="text-center block mx-auto">Prénom</Label>
          <Input
            id="firstName"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            placeholder="Prénom"
            required
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="lastName" className="text-center block mx-auto">Nom</Label>
          <Input
            id="lastName"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            placeholder="Nom"
            required
          />
        </div>
      </div>
      
      <div className="flex items-start space-x-3 pt-2">
        <Checkbox
          id="acceptNewsletter"
          checked={acceptNewsletter}
          onCheckedChange={(checked) => setAcceptNewsletter(checked as boolean)}
          required
        />
        <div className="grid gap-1.5 leading-none">
          <Label
            htmlFor="acceptNewsletter"
            className="text-sm font-medium leading-none cursor-pointer"
          >
            J'accepte de recevoir la newsletter
          </Label>
          <p className="text-sm text-muted-foreground">
            En vous inscrivant, vous acceptez de recevoir nos communications par email.
          </p>
        </div>
      </div>
      
      <Button
        type="submit"
        className={`w-full ${isModal ? 'bg-[#00123A] hover:bg-[#00123A]/90' : standalone ? 'bg-[#00123A] hover:bg-[#00123A]/90' : ''}`}
        disabled={isSubmitting}
      >
        {isSubmitting ? "Inscription en cours..." : "Je m'inscris à la newsletter"}
      </Button>
    </form>
  );
}
